import { InjectedStyledComponent } from '../InjectedStyledComponent';

export default InjectedStyledComponent('option', 'shared', ['option']);